/* __next_internal_client_entry_do_not_use__ ShipmentDelivered auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1568))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.194Z
 */ export var ShipmentDelivered = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M20 12H23.5V21H20V12Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M20 19.0937C9.5 22.5937 13 22.5937 1 16.5937C1.33715 16.1395 1.80581 15.7999 2.34245 15.621C2.87909 15.4421 3.45775 15.4326 4 15.5937L8.317 16.9607",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M20 13.5308H17C14.647 13.5308 13 15.5308 12.5 15.5308H9C8 15.5308 8 17.5308 9 17.5308H14.5",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M18 11.5308V3.53076C18 3.26555 17.8946 3.01119 17.7071 2.82366C17.5196 2.63612 17.2652 2.53076 17 2.53076H5C4.73478 2.53076 4.48043 2.63612 4.29289 2.82366C4.10536 3.01119 4 3.26555 4 3.53076V13.5938",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M8 2.53076V9.47476C7.99994 9.56948 8.02678 9.66227 8.07741 9.74233C8.12803 9.82239 8.20035 9.88642 8.28596 9.92696C8.37156 9.96751 8.46692 9.98291 8.56093 9.97137C8.65495 9.95983 8.74375 9.92181 8.817 9.86176L11 8.07276L13.183 9.86176C13.2563 9.92181 13.3451 9.95983 13.4391 9.97137C13.5331 9.98291 13.6284 9.96751 13.714 9.92696C13.7996 9.88642 13.872 9.82239 13.9226 9.74233C13.9732 9.66227 14.0001 9.56948 14 9.47476V2.53076",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "ShipmentDelivered", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
